export enum CLINIC_VERIFY_TYPE {
  CREATE_NEW = 'CREATE_NEW',
  SUGGESTED = 'SUGGESTED',
}
